import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT;

class ClientService {
    getAll() {
        return axios.get(`${API_URL}/client/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getClient(id) {
        return axios.get(`${API_URL}/client/view/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(search) {
        return axios.get(`${API_URL}/client/getFilter`, {
            params: {
                search: search,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    add(client) {
        return axios.post(`${API_URL}/client/new`, client, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    update(client) {
        return axios.put(`${API_URL}/client/update`, client, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new ClientService();